export default "__VITE_ASSET__7fpiGCe1__"